









import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Box',
  props: {
    title: {
      type: String,
      defalut: ''
    }
  },
  setup() {
  },
});
